import { t } from "i18next";

const Faq = () => {
    return (
        <section className="about_content">
            <div className="content">
                <h1 className="m_0">{t('FAQ')}</h1>
            </div>
        </section>
    );
};

export default Faq;